export const NAV_LINKS = [
  { path: "/", label: "Home" },
  { path: "/services", label: "Services" },
  { path: "/clients", label: "Clients" },
  { path: "/contact", label: "Contact" },
];
export const CLIENTS = [
  {
    name: "Star Aerospace",
    logo: null, // You can add logo path here
    industry: "Defense & Aerospace",
    location: " Dehradun, Uttarakhand",
    website: "https://www.staraerospace.org",
    featured: true,
    description:
      "Leading manufacturer in the defense industry specializing in weapon modernization and enhancement solutions for Indian Armed Forces.",
    challenge:
      "Star Aerospace needed a comprehensive AI-powered thermal detection system for their weapon enhancement products. The system had to operate reliably in all weather conditions, provide real-time threat detection, and integrate seamlessly with their existing defense technology infrastructure.",
    solution:
      "We developed a custom thermal AI detection system combining advanced computer vision algorithms with thermal imaging technology. The solution provides 24/7 monitoring capabilities with high-accuracy object detection and classification, specifically optimized for defense and security applications.",

    results: [
      "99%+ detection accuracy in all lighting conditions",
      "Real-time processing with <100ms response time",
      "Successful deployment across multiple defense installations",
      "24/7 operational capability in extreme weather conditions",
    ],
    testimonial: {
      quote:
        "The thermal AI detection system developed by LastMileService has significantly enhanced our weapon enhancement capabilities. The accuracy and reliability of their solution exceeded our expectations.",
      author: "Star Aerospace Team",
      role: "Defense Technology Division",
    },
  },
];
export const CORE_SERVICES = [
  {
    title: "Custom Software Development",
    icon: "bi-code-square",
    desc: "End-to-end development of web applications, mobile apps, and enterprise software tailored to your business requirements.",
    features: [
      "Web & Mobile Applications",
      "Enterprise Software Solutions",
      "API Development & Integration",
      "Legacy System Modernization",
    ],
  },
  {
    title: "AI & Machine Learning",
    icon: "bi-cpu-fill",
    desc: "Intelligent systems powered by artificial intelligence, computer vision, and deep learning algorithms.",
    features: [
      "Computer Vision Systems",
      "Thermal AI Detection",
      "Predictive Analytics",
      "Natural Language Processing",
    ],
  },
  {
    title: "Cloud & DevOps",
    icon: "bi-cloud-arrow-up-fill",
    desc: "Scalable cloud infrastructure, CI/CD pipelines, and automated deployment solutions for modern applications.",
    features: [
      "AWS, Azure, GCP Solutions",
      "Containerization & Orchestration",
      "CI/CD Pipeline Setup",
      "Infrastructure as Code",
    ],
  },
  {
    title: "UI/UX Design",
    icon: "bi-palette-fill",
    desc: "User-centered design creating intuitive, beautiful interfaces that enhance user experience and engagement.",
    features: [
      "Responsive Web Design",
      "Mobile App UI/UX",
      "Prototyping & Wireframing",
      "Design System Development",
    ],
  },
  {
    title: "Database Solutions",
    icon: "bi-database-fill",
    desc: "Robust database architecture, optimization, and management for efficient data storage and retrieval.",
    features: [
      "SQL & NoSQL Databases",
      "Database Migration",
      "Performance Optimization",
      "Data Warehouse Solutions",
    ],
  },
  {
    title: "System Integration",
    icon: "bi-diagram-3-fill",
    desc: "Seamless integration of third-party services, APIs, and existing systems into your application ecosystem.",
    features: [
      "Third-party API Integration",
      "Payment Gateway Setup",
      "CRM & ERP Integration",
      "Microservices Architecture",
    ],
  },
];

export const TECH_STACK = [
  {
    category: "Frontend",
    icon: "bi-window-sidebar",
    technologies: [
      "React",
      "Angular",
      "Vue.js",
      "Next.js",
      "TypeScript",
      "Tailwind CSS",
    ],
  },
  {
    category: "Backend",
    icon: "bi-server",
    technologies: ["Node.js", "Python", "Java", "PHP", ".NET", "Go"],
  },
  {
    category: "Mobile",
    icon: "bi-phone-fill",
    technologies: ["React Native", "Flutter", "Swift", "Kotlin", "Ionic"],
  },
  {
    category: "AI/ML",
    icon: "bi-robot",
    technologies: ["TensorFlow", "PyTorch", "OpenCV", "Keras", "scikit-learn"],
  },
  {
    category: "Database",
    icon: "bi-database-fill-gear",
    technologies: ["PostgreSQL", "MongoDB", "MySQL", "Redis", "Firebase"],
  },
  {
    category: "Cloud",
    icon: "bi-cloud-fill",
    technologies: ["AWS", "Azure", "GCP", "Docker", "Kubernetes"],
  },
  {
    category: "DevOps",
    icon: "bi-gear-wide-connected",
    technologies: [
      "Jenkins",
      "GitLab CI",
      "GitHub Actions",
      "Terraform",
      "Ansible",
    ],
  },
  {
    category: "Tools",
    icon: "bi-tools",
    technologies: ["Git", "Jira", "Slack", "Postman", "VS Code"],
  },
];
export const FEATURES = [
  {
    title: "Thermal AI Detection",
    desc: "Real-time heat-based detection using advanced AI models.",
  },
  {
    title: "Day & Night Vision",
    desc: "Reliable imaging in daylight, smoke, fog, and total darkness.",
  },
  {
    title: "Smart Alerts",
    desc: "Context-aware alerts with minimal false positives.",
  },
];

export const SERVICES = [
  {
    title: "AI Software Development for Detection ",
    desc: "End-to-end development of AI-driven software solutions that enhance thermal camera systems with intelligent detection, analytics, and automation.",
  },
  {
    title: "Computer Vision & Machine Learning",
    desc: "Design and training of advanced computer vision models specifically optimized for thermal imagery and heat-based analysis.",
  },
  {
    title: " Data Analysis & Model Training",
    desc: "We assist in collecting, labeling, and training AI models using thermal datasets to achieve high accuracy and reliability.",
  },
  {
    title: "System Integration & API Development",
    desc: "Seamless integration of AI software with existing thermal camera hardware, VMS platforms, dashboards, and third-party systems.",
  },
  {
    title: "Performance Optimization & Scaling",
    desc: "Optimize AI models for real-time processing, edge deployment, and large-scale monitoring environments.",
  },
  {
    title: "Consulting & Technical Support",
    desc: "Expert guidance, architecture design, and ongoing support for companies developing or deploying AI-powered thermal camera solutions.",
  },
];
// export const DEMOVIDEOS = [
//   "http://localhost:8080/videos/thermal-demo-1.mp4",
//   "http://localhost:8080/videos/thermal-demo-2.mp4",
//   "http://localhost:8080/videos/thermal-demo-3.mp4",
// ];
